// src/utils/tokenUtils.js

export function isTokenValid(token) {
  if (!token) return false;

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const expiresAtMs = payload.exp * 1000;
    return Date.now() < expiresAtMs;
  } catch {
    return false;
  }
}

export function getDashboardRoute(userType) {
  if (userType === "Freelancer") return "/dashboard-freelancer";
  if (userType === "Company") return "/dashboard-company";
  if (userType === "Admin") return "/dashboard-admin";
  return "/";
}